export function truncate(string: string, maxLength = 20): string {
  if (!string) return ''
  if (string.length <= maxLength) return string
  return `${string.substring(0, maxLength)}...`
}

export function timeToRead(text: string): number {
  return Math.ceil(text.split(' ').length / 250)
}
